export default __webpack_public_path__ + "static/media/text-large.4d0dc6fb.svg";